import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useLocalStorage, } from "./useLocalStorage";
import { useAuth } from 'hooks/AuthContext';
import { getListSettingAPI, setListSettingAPI } from 'api/common';


const MenuTableAuthContext = createContext();

export const TableProvider = ({ children }) => {
  const [openMenuInfo, setOpenMenuInfo] = useLocalStorage("openMenuInfo", null);
  const [col, setCol] = useLocalStorage("col", null);
  const { user, userMenu } = useAuth();

  //선택한 메뉴 정보
  const fnOpenMenuInfo = async (data) => {
    try{
      setOpenMenuInfo(data);
    }catch(err){
      console.log(err)
    }
  }

  // //표설정 리스트
  // const getTableItem = async (data) => {
    
  //   const dataSet = {
  //     userIdx : user.user_idx,
  //     menuIdx: openMenuInfo.id
  //   }
  //   try{
  //     const res = await getListSettingAPI(dataSet);
  //     console.log("&&&&",res.data.data_list);
  //     let arr = []
  //     res.data.data_list.map((it)=>{
  //       if(it.LIST_STATUS < 2){
  //         const obj = {
  //             sortNo: it.LIST_SORT_NO,
  //             status: it.LIST_STATUS,
  //             title: it.LIST_ITEM_NAME,
  //             dataIndex: it.LIST_COLUMN_NAME,
  //           }
  //           arr.push(obj);
  //       }
  //     })
  //     setCol(arr);
  //     return arr
  //   }catch(err){
  //     console.log(err);
  //   }

  // };
  //표설정 변경
  // const setTableItem = async (data) => {
  //   try { 
  //     const res = await setListSettingAPI(user.user_idx, openMenuInfo.id, data);
  //     if(res.status === 200) {
  //       const dataSet = {userIdx : user.user_idx, menuIdx: openMenuInfo.id}
  //       const res = getTableItem();
  //       return res
  //     }else(
  //       alert('적용되지 않았습니다. 관리자에게 문의바랍니다.')
  //     )
  //   }catch(err){
  //     console.log(err);
  //   }
  // };

useEffect(()=>{
},[col])

//통계
  const statItem = (data) => {
    // setUser({token: data.login_token, user_idx: data.user_idx, user_level: data.level_no});
    // setUserMenu(data.menu_list);
    // console.log(">",data);
  };
 
  const value = useMemo(
    () => {
        const location = window.location.pathname;
        if(user && location !== openMenuInfo?.url){
          const changedMenu = userMenu.filter(it => it.MENU_URL === location)[0];
          if(changedMenu){
            fnOpenMenuInfo({...openMenuInfo, id:changedMenu.IDX, code:changedMenu.DEPTH2_MENU_CD, url:location})
          }
        }
        return {
          col,
          openMenuInfo,
          fnOpenMenuInfo,
          // getTableItem,
          // setTableItem,
        }
    },
    [children,openMenuInfo]
  );
  return <MenuTableAuthContext.Provider value={value}>{children}</MenuTableAuthContext.Provider>;
};

export const useTableContext = () => {
  return useContext(MenuTableAuthContext);
};
